import * as yup from 'yup';
import { AppTFunction } from '@retail/app/i18n';
import { vilmaVersion, VilmaVersion } from '@retail/export/types';

export type DownloadSelection = 'date' | 'sinceLastDownload' | 'all';
export const downloadSelection = ['date', 'sinceLastDownload', 'all'] as const;

export const exportSchema = (tApp: AppTFunction) =>
  yup
    .object({
      downloadSelection: yup
        .mixed<DownloadSelection>()
        .oneOf(Object.values(downloadSelection))
        .default('date')
        .required(),
      vilmaVersion: yup
        .mixed<VilmaVersion>()
        .oneOf(Object.values(vilmaVersion))
        .default('VILMA_27')
        .required(),
      numberOfFutureDays: yup
        .number()
        .min(0, tApp('calculus.error.mustBeNumberBetween', { min: 0, max: 21 }))
        .max(21, tApp('calculus.error.mustBeNumberBetween', { min: 0, max: 21 }))
        .optional()
        .nullable()
        .typeError(tApp('calculus.error.mustBeNumberBetween', { min: 0, max: 21 })),
      fromDate: yup.date().when('downloadSelection', {
        is: false,
        then: yup
          .date()
          .default(undefined)
          .typeError(tApp('export.errors.dateOrCheckboxRequired'))
          .required(tApp('export.errors.dateOrCheckboxRequired')),
        otherwise: yup.date().default(undefined).nullable(),
      }),
    })
    .required();

export type ExportSchema = yup.InferType<ReturnType<typeof exportSchema>>;
